import React from 'react';
import { Box, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faEnvelope, faHandHoldingHand } from '@fortawesome/free-solid-svg-icons';

const BottomBorder = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: { xs: 'flex-start', md: 'space-between' },
        alignItems: { xs: 'flex-start', md: 'center' },
        px: { xs: 2, sm: 3, md: 6 },
        py: { xs: 1, sm: 1.2, md: 1 },
        backgroundColor: 'black',
        color: 'white',
        fontFamily: 'Noto Sans, sans-serif',
        gap: { xs: 0.1, md: 0 },
        width: '100%',
      }}
    >
      {/* Top: Name + Icon */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: { xs: 0.2, md: 0 } }}>
        <Typography
          sx={{
            fontWeight: 'bold',
            fontSize: { xs: '0.475rem', sm: '0.6rem', md: '1rem' },
            paddingLeft: { md: '0.5rem' },
            paddingRight: { md: '0.3rem' },
            lineHeight: 1,
          }}
        >
          Elena DiRusso, DO
        </Typography>
        <Box
          component={FontAwesomeIcon}
          icon={faHandHoldingHand}
          sx={{
            fontSize: { xs: '0.5rem', sm: '0.6rem', md: '0.8rem' },
            pb: '0.1rem',
          }}
        />
      </Box>

      {/* Middle: Message */}
      <Box
        sx={{
          maxWidth: { xs: '100%', md: 1000 },
          textAlign: { xs: 'left', md: 'left' },
          mt: { xs: 0, md: 0 },
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: '0.325rem', sm: '0.375rem', md: '0.55rem' },
            lineHeight: 1.4,
            pr: { md: '4rem' },
          }}
        >
          Please contact us at least 24 hrs in advance if you need to cancel or reschedule your appointment.
          <br />
          Located just up the hill from the Dobbs Ferry Metro-North station right in Westchester County.
        </Typography>
      </Box>

      {/* Right: Icons */}
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          alignItems: 'center',
          pt: { xs: 0, md: 0 },
        }}
      >
        <a
          href="mailto:elenadirussoresidency@gmail.com"
          style={{ color: 'inherit' }}
        >
          <Box
            component={FontAwesomeIcon}
            icon={faEnvelope}
            sx={{ fontSize: { xs: '0.5rem', sm: '0.6rem', md: '0.8rem' } }}
          />
        </a>
        <a
          href="https://www.google.com/maps/place/55+Livingston+Ave,+Dobbs+Ferry,+NY"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'inherit' }}
        >
          <Box
            component={FontAwesomeIcon}
            icon={faMapMarkerAlt}
            sx={{ fontSize: { xs: '0.5rem', sm: '0.6rem', md: '0.8rem' } }}
          />
        </a>
      </Box>
    </Box>
  );
};

export default BottomBorder;
